import { ModuleDocuments } from '@modules/remotes/orders/documents';

export function DocumentManagement() {
  return <ModuleDocuments />;
}
